// React
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
// MUI
import { Card, Stack, Button, Container, Typography, Dialog, Popper, DialogActions, DialogContent, DialogTitle, TextField } from "@mui/material";

import Iconify from "../../../components/iconify/Iconify";
// Components
import GoTable from "../../../common/GoTable/GoTable";
import GoDrawer from "../../../components/Inputs/GoDrawer";
import School from "./School";
// Constants
import { SCHOOL_TABLE_HEADS } from "../../../configs/TableHeaderConstants";
import EntityConstants from "../../../configs/EntityConstants";
import PermissionConstants from "../../../configs/PermissionConstants";
// Services
import { get } from "../../../services/FetchHelper";
import SpinService from "../../../services/SpinService";
// Hooks
import usePermissions from "../../../hooks/usePermissions";
import Filter from "./Filter";

const Schools = () => {
    const permissions = usePermissions();
    const spinService = SpinService();
    const navigate = useNavigate();
    const [open, setOpen] = useState(false);
    const [id, setId] = useState(undefined);
    const [openFilter, setOpenFilter] = useState(false);
    const [filter, setFilter] = useState({
        sort: "id",
        order: "desc",
        max: 10,
        offset: 0,
        search: "",
        queryFilters: "{}"
    });

    const [schools, setSchools] = useState({
        entries: [],
        total_count: 0
    });

    const getSchools = async () => {
        spinService.on();
        const params = new URLSearchParams({
            sort: filter.sort,
            order: filter.order,
            max: filter.max,
            offset: filter.offset + 1,
            search: filter.search,
            queryFilters: filter.queryFilters
        });

        const response = await get(EntityConstants.SCHOOLS, params);
        const data = await response.json();
        spinService.off();
        setSchools(data);
    };

    const onClose = () => {
        getSchools();
        setId(undefined);
        setOpen(false);
        setOpenFilter(false);
    };

    useEffect(() => {
        if (permissions.has(PermissionConstants.SCHOOL_VIEW)) {
            getSchools();
        } else {
            navigate("/");
        };
    }, [filter]);

    return (
        <React.Fragment>
            <Container maxWidth={false}>
                <Stack
                    direction="row"
                    alignItems="center"
                    justifyContent="space-between"
                    mb={2}
                >
                    <Typography variant="h4" gutterBottom>
                        Schools
                    </Typography>
                    {permissions.has(PermissionConstants.SCHOOL_CREATE) && <Button
                        variant="contained"
                        startIcon={<Iconify icon="eva:plus-fill" />}
                        onClick={() => { setId(undefined); setOpen(true) }}
                    >
                        New School
                    </Button>}
                </Stack>
                <Card>
                    <GoTable
                        tableHeads={SCHOOL_TABLE_HEADS}
                        tableDatas={schools.entries}
                        totalCount={schools.total_count}
                        filter={filter}
                        onFilter={(filter) => setFilter((prevState) => {
                            return {
                                ...prevState,
                                sort: filter.sort,
                                order: filter.order,
                                max: filter.max,
                                offset: filter.offset,
                                search: filter.search,
                            }
                        })}
                        onView={(row) => { setId(row.id); setOpen(true) }}
                        openFilter={() => setOpenFilter(true)}
                        customFilter={true}
                    />
                </Card>
            </Container>

            {
                permissions.has(PermissionConstants.SCHOOL_VIEW) && open && <GoDrawer
                    title="School"
                    open={open}
                    onClose={() => onClose()}
                >
                    <School id={id} onClose={() => onClose()} />
                </GoDrawer>
            }

            {
                openFilter && <Filter
                    queryFilters={filter.queryFilters}
                    openFilter={openFilter}
                    onClose={() => onClose()}
                    onFilters={(filterQuries) => setFilter((prevState) => { return { ...prevState, queryFilters: JSON.stringify(filterQuries) } })} />
            }
        </React.Fragment>
    );
}

export default Schools;